import Lottie, { type LottieComponentProps } from 'lottie-react';
import { twMerge } from 'tailwind-merge';
import dropletAnimation from '@/assets/lottie/droplet.json';

type LoadingSpinnerProps = Omit<LottieComponentProps, 'animationData'>;

const LoadingSpinner = (props: LoadingSpinnerProps) => {
	return (
		<Lottie
			animationData={dropletAnimation}
			loop
			autoPlay
			{...props}
			className={twMerge(
				'-translate-1/2 absolute top-1/2 left-1/2 z-50',
				props.className,
			)}
		/>
	);
};

export default LoadingSpinner;
